import { Link } from "react-router-dom";
import { SiteFooter } from "@/components/SiteFooter";
import { SiteAnnouncementBar } from "@/components/SiteAnnouncementBar";

export function LegalPageShell({
    title,
    effectiveDate,
    children,
    backTo = "/register",
    backLabel = "Back to registration",
    testId = "legal-page",
}) {
    return (
        <div className="auth-route-root legal-page" data-testid={testId}>
            <SiteAnnouncementBar audience="auth" />
            <div className="mx-auto max-w-3xl px-6 py-12 sm:py-16 pb-20">
                <div className="mb-10">
                    <Link to={backTo} className="text-sm text-[#00BF0D] hover:underline">
                        ← {backLabel}
                    </Link>
                    <h1 className="mt-6 font-heading text-3xl tracking-tight sm:text-4xl">{title}</h1>
                    <p className="mt-2 text-sm text-white/50">Effective date: {effectiveDate}</p>
                </div>
                <article className="space-y-8 text-sm leading-relaxed text-white/70">{children}</article>
                <SiteFooter variant="compact" className="mt-12" />
            </div>
        </div>
    );
}
